import React from "react";
import OtpImg from "../../../styles/img/otp-img.png";

export const OtpModal = (props) => {
  return (
    <>
      <div
        className={
          props.className ? props.className : "df-confirmation-message-popup"
        }
      >
        <img src={OtpImg} className="w-100 df-otp-img" />
        <h3 className="df-confirmation-message-popup__message">
          {props.message}
        </h3>
        {props.children}
      </div>
    </>
  );
};
